
/* eslint-disable camelcase */
import jwt_decode from "jwt-decode";



//TODO - ERROR - custom:document
// interface JWTProps {
//   name: string;
//   email: string;
//   custom:document;
//   document: string;
//   scope: string;
//   client_id: string;
//   exp?: string;
// }

export const decodeJWT = (jwt: string): any => {
  return jwt_decode<any>(jwt);
};

export const getUserInfoFromJWT = (
  jwt: string,
  fields: Array<string>,
): Record<string, any> => {
  const decoded = decodeJWT(jwt);
  const userInfos: Record<string, any> = {};
  fields.forEach((field) => {
    if (decoded[field]) {
      userInfos[field] = decoded[field];
    }
  });

  return userInfos;
};
